export const GET_USERS = "@iweb/GET_USERS"
export const SELECT_USER = "@iweb/SELECT_USER"
export const USER_LOADING = "@iweb/USER_LOADING"
export const EDIT_USER_ADMIN_STATUS = "@iweb/EDIT_USER_ADMIN_STATUS"
export const CREATE_ADMIN = "@iweb/CREATE_ADMIN"
